// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"4662ed13","211":"a08ee7bc","519":"b4fc3e25","598":"c3680a7e","816":"12dedbcc"}[chunkId] + ".chunk.css";
};